import { CombinedGraphQLErrors } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { isNestJsGraphQLError, logErrorMessages } from '@pcg/graphql-kit';

import { goToLogin } from '@/shared/tools/auth';
import { generateRequestId } from '@ugi/core';
import { getCurrentScreen } from './current-screen';

export const apolloRequestIdLink = setContext((_, { headers }) => {
  const screen = getCurrentScreen();

  return {
    headers: {
      ...headers,
      'x-request-id': generateRequestId(),
      // Журнал змін: з якого екрана прийшла зміна.
      ...(screen ? { 'x-ugi-screen': screen } : {}),
    },
  };
});

export const apolloErrorLink = onError((handlerOpts) => {
  const { error } = handlerOpts;

  if (!CombinedGraphQLErrors.is(error)) {
    return;
  }

  const unauthenticated = error.errors.some(
    (err) =>
      isNestJsGraphQLError(err)
      && (err.extensions.statusCode === 401
        || err.extensions.key === 'SESSION_INVALID'
        || err.extensions.key === 'SESSION_EXPIRED'
        || err.extensions.key === 'ACCESS_TOKEN_EXPIRED'
        || err.extensions.key === 'ACCESS_TOKEN_INVALID'),
  );

  if (unauthenticated) {
    goToLogin();

    return;
  }

  for (const err of error.errors) {
    if (!isNestJsGraphQLError(err)) {
      continue;
    }

    logErrorMessages(handlerOpts);
  }
});
